import React from "react"
import { RoundedRectangle } from "../atoms/roundedrectangle/RoundedRectangle"
import { RRIconBar } from "../atoms/roundedrectangle/RRIconBar"
import { Spacer } from "../atoms/Atoms"
import { BodyLarge, BodySmall } from "../atoms/Bodies"
import { ArrowLink } from "../atoms/links/ArrowLink"
import { Button } from "../atoms/buttons/Button"

const FindAProviderModuleTemplate = ({ title, bodyCopy, ctaCopy, ctaUri }) => (
  <RoundedRectangle backgroundColor="light-gray">
    <RRIconBar iconName="icn-find" backgroundColor="white-70" />
    <BodyLarge color="black-80">{title}</BodyLarge>
    <Spacer height={1} />
    {bodyCopy && (
      <>
        <BodySmall color="black-80">{bodyCopy}</BodySmall>
        <Spacer height={1} />
      </>
    )}
    <div className="db dn-l">
      <ArrowLink to={ctaUri}>{ctaCopy}</ArrowLink>
    </div>
    <div className="dn db-l">
      <Button outline to={ctaUri}>
        {ctaCopy}
      </Button>
    </div>
  </RoundedRectangle>
)

export { FindAProviderModuleTemplate }
